import { render, staticRenderFns } from "./MamTab.vue?vue&type=template&id=4e4a4c22"
import script from "./MamTab.vue?vue&type=script&lang=js"
export * from "./MamTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports